export var genericTypeToOption = function (genericType, labelProperty) {
    if (labelProperty === void 0) { labelProperty = "description"; }
    return {
        value: genericType.id.toString(),
        label: genericType[labelProperty],
    };
};
